export const workshopList = [{
    title: 'Date',
    dataIndex: 'date',
    key: 'date',
    width: 100,
    render: date => {
      var str = date.split("-");
      var fYear = str[0],
          fMonth = str[1],
          fDay = str[2];

      return fDay + "-" + fMonth + "-" + fYear;
    }
  },{
    title: 'Vehicle',
    dataIndex: 'on',
    key: 'vehicle',
    width: 100,
  },{
    title: 'Completed by',
    dataIndex: 'completedBy',
    key: 'completedby',
    width: 100,
  }];